/**
 * Hook for comment AI actions: summarize and teach.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { contentFeedbackService } from '../services/contentFeedbackService';

export function useSummarizeComments(contentId: string | null) {
	return useMutation({
		mutationFn: () => {
			if (!contentId) throw new Error('No content ID');
			return contentFeedbackService.summarizeComments(contentId);
		},
	});
}

export function useTeachComment(contentId: string | null) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ commentId, description }: { commentId: string; description?: string }) => {
			if (!contentId) throw new Error('No content ID');
			return contentFeedbackService.teachComment(contentId, commentId, description);
		},
		onSuccess: () => {
			// Invalidate comments so UI can reflect the taught state
			queryClient.invalidateQueries({
				queryKey: ['content-comments', contentId],
			});
		},
	});
}
